<template>
  <div 
    v-scroll-behaviour
    :class="{'--dropdown-active': openCategories || hamburgerState || openSearch,
      '--scrolled': isScrolled,
      '--nav-up': navTop && isNavUp }"
    class="glaxi-menu">
    
    <MenuDesktop @toggle-categories="toggleCategories" @toggle-search="toggleSearch" :open="openCategories" :openSearch="openSearch"/>
    <MenuMobile @close-categories="closeCategories" @toggle-categories="toggleCategories" @toggle-search="toggleSearch" @hamburger-click="hamburgerClick" :open="openCategories" :openSearch="openSearch" :hamburgerState="hamburgerState" ref="closeMobile"/>
    <MenuCategories @toggle-categories="toggleCategories" :open="openCategories"/>
    <MenuSearch :open="openSearch"/>
    
  </div>
</template>

<script>
/* gestire apertura menu in timeline?
import { TweenLite } from 'gsap/TweenLite'
import { TweenMax } from 'gsap/TweenMax'
*/
import MenuDesktop from '@/components/GlaxiMenu/MenuDesktop/MenuDesktop.vue'
import MenuMobile from '@/components/GlaxiMenu/MenuMobile/MenuMobile.vue'
import MenuCategories from '@/components/GlaxiMenu/MenuCategories/MenuCategories.vue'
import MenuSearch from '@/components/GlaxiMenu/MenuSearch/MenuSearch.vue'

export default {
  name: 'GlaxiMenu',
  components: {
    MenuDesktop,
    MenuMobile,
    MenuCategories,
    MenuSearch
  },
  data: () => ({
    logo: require('@/assets/footer/logo-glaxi.svg'),
    hamburgerState: false, // true is active (open)
    openCategories: false,  // true is active (open)
    openSearch: false,  // true is active (open)
    scrollY: 0,
    oldScrollY: 0,
    navTop: false,
    menuHeight: 0,
  }),
  computed: {
    isScrolled: {
      get () {
        return this.scrollY > window.innerHeight + this.menuHeight
      }
    },
    isNavUp: {
      get () {
        return this.scrollY > this.menuHeight
      }
    }
  },
  methods: {
    hamburgerClick (event) {
      this.hamburgerState = !this.hamburgerState
      if (!this.hamburgerState){
        this.openCategories = false
      }
      this.openSearch = false
    },
    toggleCategories() {
      this.openCategories = !this.openCategories
      this.openSearch = false
      if (this.openCategories) {
        // hamburgerState: false
      }
    },
    toggleSearch() {
      this.openSearch = !this.openSearch
      this.openCategories = false
      this.$refs.closeMobile.close()
    },
    close () {
      this.openCategories = false
      this.openSearch = false
      this.hamburgerState = false
      this.$refs.closeMobile.close()
    },
    closeCategories () {
      this.openCategories = false
      this.hamburgerState = false
    }
  },
  directives: {
    'scroll-behaviour': {
      bind (el, binding, vnode, oldVnode) {
        window.addEventListener('scroll', (e) => {
          vnode.context.scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
          vnode.context.navTop = vnode.context.scrollY > vnode.context.oldScrollY

          vnode.context.oldScrollY = vnode.context.scrollY
          vnode.context.menuHeight = el.getBoundingClientRect().height
        }, { passive: true })
      }
    }
  }
}
</script>


<style lang="scss">
  @import "./scroll.scss";
</style>
